var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4.773,
    height: 8.374,
    viewBox: "0 0 4.773 8.374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(106.787 8.091) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.298 0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0.5px",
    d: "M103.023,3.906,106.416.513a.3.3,0,0,0-.425-.425l-3.606,3.606a.3.3,0,0,0,0,.425l3.606,3.606a.3.3,0,0,0,.425-.425Z",
    transform: "translate(-102.298 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextStep);
export default __webpack_public_path__ + "static/media/next-step.7faa15ae.svg";
export { ForwardRef as ReactComponent };